
import React, {FC, useEffect} from 'react';

import Close from './svgs/close.inline.svg';

import * as styles from './styles.module.scss';

type MobileWrapperProps = {
	onClose: () => void
	side: 'left' | 'right'
	children: React.ReactNode
}

const MobileWrapper: FC<MobileWrapperProps> = ({children, side, onClose}) => {
	useEffect(() => {
		const {body} = window.document;
		body.style.overflow = 'hidden';
		return () => {
			body.style.overflow = 'unset';
		};
	}, []);

	return (
		<div className={styles.wrapper}>
			{side === 'left' && (
				<div className={styles.nav}>
					{children}
				</div>
			)}
			<div className={styles.close} onClick={(e) => e.stopPropagation()}>
				<Close onClick={onClose} />
			</div>
			{side === 'right' && (
				<div className={styles.nav}>
					{children}
				</div>
			)}
		</div>
	);
};

export default MobileWrapper;
